import { useState, useEffect, useCallback } from 'react';
import InputField from 'components/fields/InputField';
import { IFilter } from 'types';
import { debounce } from 'utils';

interface FilterProps {
  filter: IFilter;
  value: any;
  onChange: (value: any) => void;
}

const FilterComponent: React.FC<FilterProps> = ({
  filter,
  value: propValue,
  onChange,
}) => {
  const [localValue, setLocalValue] = useState(propValue);

  useEffect(() => {
    setLocalValue(propValue);
  }, [propValue]);

  const debouncedOnChange = useCallback(debounce(onChange, 300), [onChange]);

  const handleChange = (event: React.ChangeEvent<any>) => {
    setLocalValue(event.target.value);
    debouncedOnChange(event.target.value);
  };
  const { key, type, options, label } = filter;

  switch (type) {
    case 'select':
      return (
        <label className="ml-1.5 text-sm font-medium text-navy-700 dark:text-white">
          {label}
          <select
            value={localValue}
            onChange={handleChange}
            className={` mt-2 flex h-12  items-center justify-center rounded-xl border bg-white/0 p-3 pr-5 text-sm  outline-none ${
              localValue ? 'text-black' : 'text-gray-400'
            }`}
          >
            <option style={{ display: 'none' }} hidden selected>
              {label}
            </option>
            {options?.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </label>
      );
    default:
      return (
        <InputField
          type={type}
          value={localValue}
          onChange={handleChange}
          id={key}
          name={key}
          label={label}
          placeholder={label}
        />
      );
  }
};

export default FilterComponent;
